import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const constApi = {
  // 嘉年华配置信息
  carnival_config: baseAPI + baseUrl + 'official/starry_config/query_config',
  carnival_update: baseAPI + baseUrl + 'official/starry_config/change_config',
  resource_list: baseAPI + baseUrl + 'official/starry_config/get_reward_type_config',
  resource_info: baseAPI + baseUrl + 'official/starry_config/get_reward_info',
}

/**
 * 获取嘉年华配置信息
 * @param {Object} chapterId - 场次Id
 * @returns {Promise} 接口数据
 */
export const getCarnivalConfigReq = async (chapterId) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.carnival_config,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      chapterId
    }
  })
  return res
};

/**
 * 保存嘉年华配置信息
 * @param {Object} data - 用户参数
 * @param {String} data.token - user token
 * @param {String} data.uid - user uid
 * @returns {Promise} 接口数据
 */
export const saveCarnivalConfigReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.carnival_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
};


/**
 * 获取资源列表
 * @returns {Promise} 接口数据
 */
export const getResourceListReq = async () => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.resource_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  })
  return res
};

/**
 * 获取嘉年华配置信息
 * @param {Object} data - 用户参数
 * @param {String} data.rewardId - 资源ID
 * @param {String} data.type - 资源类型
 * @returns {Promise} 接口数据
 */
export const getResourceInfoReq = async (data) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.resource_info,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...data
    }
  })
  return res
};

